module.exports = __webpack_public_path__ + "r.no1.11ba039f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/r.no1.jpg
// module id = +V1t
// module chunks = 0